import React, { Component, Fragment } from "react";
import gql from "graphql-tag";
import { Query, Mutation } from "react-apollo";
import { Button, Container, Header } from "semantic-ui-react";
import Application from "./Application";
import ApplicationForm from "./ApplicationForm";
import { withLanguage } from 'HOCs'

import { APPLICATIONS_QUERY } from "../../graphql/queries";

class ApplicationsList extends Component {
  state = {
    newApplicationFormVisibility: false,
  };
  showApplicationForm = () => {
    this.setState({ newApplicationFormVisibility: true });
  };
  hideApplicationForm = () => {
    this.setState({ newApplicationFormVisibility: false });
  };
  render() {
    const {language} = this.props
    return (
      <Container>
        <Header as="h1">Applications</Header>
        {this.state.newApplicationFormVisibility ? (
          <Mutation
            mutation={CREATE_APPLICATION}
            update={(cache, { data: { createApplication } }) => {
              const { applications } = cache.readQuery({
                query: APPLICATIONS_QUERY,
                variables: {language}
              });
              cache.writeQuery({
                query: APPLICATIONS_QUERY,
                variables: {language},
                data: { applications: [createApplication, ...applications] }
              });
            }}
          >
            {(createApplication, { loading: createLoading, error: createError }) => {
              const addApplication = input =>
                createApplication({
                  variables: { language, input }
                });
              return (
                <ApplicationForm
                  hide={this.hideApplicationForm}
                  submit={addApplication}
                  loading={createLoading}
                />
              );
            }}
          </Mutation>
        ) : (
          <Button primary onClick={this.showApplicationForm}>
            Add New Application
          </Button>
        )}
        <Query
          query={APPLICATIONS_QUERY}
          variables={{ language }}
          fetchPolicy="network-only"
        >
          {({ data, fetchMore, error }) => {
            if (data && data.applications) {
              return (
                  <Fragment>
                  {data.applications.map(application => {
                    return (
                      <Mutation
                        mutation={UPDATE_APPLICATION}

                        key={application.id}
                        update={(cache, { data }) => {
                          const { applications } = cache.readQuery({
                            query: APPLICATIONS_QUERY,
                            variables: {language}
                          });
                          cache.writeQuery({
                            query: APPLICATIONS_QUERY,
                            variables: {language},
                            data: {
                              applications: applications.map(application =>
                                application.id === data.updateApplication.id
                                  ? data.updateApplication
                                  : application
                              )
                            }
                          });
                        }}
                      >
                        {(
                          updateApplication,
                          { loading: updateLoading, error: updateError }
                        ) => {
                          console.log(language)
                              const edit = name =>
                                updateApplication({
                                  variables: {
                                    language,
                                    id: application.id,
                                    input: { name }
                                  }
                                });
                              return (
                                <Application
                                  key={application.id}
                                  id={application.id}
                                  name={application.name}
                                  edit={edit}
                                  updateLoading={updateLoading}
                                />
                              );
                            }}
                          </Mutation>
                        )})}
                        </Fragment>
                  )    
            }
            return null;
          }}
        </Query>
      </Container>
    );
  }
}

export const CREATE_APPLICATION = gql`
  mutation CreateApplication( $language: String!, $input: CreateApplicationInput!) {
    createApplication(language: $language, input: $input) {
      id
      name
    }
  }
`;

export const UPDATE_APPLICATION = gql`
  mutation UpdateApplication( $language: String!, $id: ID!, $input: UpdateApplicationInput!) {
    updateApplication( language: $language, id: $id, input: $input) {
      id
      name
    }
  }
`;

export default withLanguage(ApplicationsList);


// WEBPACK FOOTER //
// ./src/pages/Applications/index.js